import { combineReducers } from 'redux';
import workflows from './workflows';
import statuses from './statuses';


export default combineReducers({
    workflows,
    statuses,
});
